import script from "./Availability.vue?vue&type=script&setup=true&lang=js"
export * from "./Availability.vue?vue&type=script&setup=true&lang=js"

import "./Availability.vue?vue&type=style&index=0&id=82395ef6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src488305949/src/haydenfarmstownhomes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82395ef6"]])

export default __exports__